var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"fade"}},[(_vm.active)?_c('div',{staticClass:"loading-mask"},[(_vm.spinner)?_c('i',{staticClass:"far fa-spinner-third fa-spin"}):_vm._e(),(_vm.text)?_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }